import type { WorkflowFilterStatus } from '@app/shared/types/sf-data'
import type { WorkflowOverviewItem, WorkflowOverviewGroup } from './types'

export const determineFilterValue = ({
  allowedFilterValues,
  defaultFilterValue,
  incomingFilter,
}: {
  allowedFilterValues: WorkflowFilterStatus[]
  defaultFilterValue: WorkflowFilterStatus
  incomingFilter: WorkflowFilterStatus
}): WorkflowFilterStatus => {
  if (!incomingFilter || !allowedFilterValues.includes(incomingFilter)) {
    return defaultFilterValue
  }

  // Different screens might have different interpretations of the 'show-all' filter
  if (incomingFilter === 'show-all') {
    return defaultFilterValue
  }

  return incomingFilter
}

export function findAccountId(
  items: Array<WorkflowOverviewItem | WorkflowOverviewGroup>,
  accountEntryId: number
): number | null {
  for (const item of items) {
    if (
      'type' in item &&
      item.type === 'account_entry' &&
      'accountEntryId' in item &&
      item.accountEntryId === accountEntryId
    ) {
      return item.id
    }
    if (
      'children' in item &&
      item.children &&
      Array.isArray(item.children) &&
      item.children.length > 0
    ) {
      const found = findAccountId(item.children, accountEntryId)
      if (found) return found
    }
  }
  return null
}

export function getItemDataAttrs(
  item: WorkflowOverviewItem | WorkflowOverviewGroup
): Record<string, string | number | undefined> {
  if ('type' in item) {
    return {
      'data-item-type': item.type,
      'data-item-id': item.type === 'reconciliation_text' ? item.id : undefined,
      'data-account-id': item.type === 'account_entry' ? item.id : undefined,
      'data-account-entry-id':
        item.type === 'account_entry'
          ? item.accountEntryId || undefined
          : undefined,
    }
  }
  return {}
}
